import { useEffect, useState } from "react";
import usePortalAppService from "services/portal-app";
import { useRoleService } from "services/security";
import useCOPOrganizationService from "services/organization";
import { useAppStatus } from "@wexinc/wex-common-web";

type AppBootstrapperProps = {
  children: React.ReactNode;
};

const AppBootstrapper: React.FC<AppBootstrapperProps> = (props) => {
  const portalAppService = usePortalAppService();
  const roleService = useRoleService();
  const copOrganizationService = useCOPOrganizationService();
  const [processing, setProcessing] = useState(true);
  const appStatus = useAppStatus();

  useEffect(() => {
    async function bootstrap() {
      // add other store initializers here and to the Promise.all below
      await Promise.all([
        portalAppService.ensurePortalAppStoreIsInitialized(),
        roleService.ensureAuthorizationStoreIsInitialized(),
        copOrganizationService.ensureAuthorizationStoreIsInitialized(),
      ]);

      setProcessing(false);
      appStatus.setAppStatus("end-appbootstrap");
    }
    bootstrap();
    appStatus.setAppStatus("begin-appbootstrap");
    // eslint-disable-next-line
  }, []);

  return <>{!processing && props.children}</>;
};

export default AppBootstrapper;
